/* Personalized products need the "Make it yours" box on their own page, so the
   theme's quick-view drawer must never add one to the cart without a letter. For a
   personalized product (its handle contains "personalized"), the drawer's buy buttons
   are swapped for a "Personalize it" button that opens the product page. Other
   products keep their buy buttons. Loaded on every page from pp-search-toggle. */
(function () {
  function productUrl(modal) {
    /* The theme puts the product's address on the drawer; the card's link is a fallback. */
    var own = modal.getAttribute('data-product-url');
    if (own) return own.split('?')[0];
    var scopes = [modal, modal.closest('.product-card, .card, product-card, li, .card-wrapper')];
    for (var s = 0; s < scopes.length; s++) {
      var a = scopes[s] && scopes[s].querySelector('a[href*="/products/"]');
      if (a) return a.getAttribute('href').split('?')[0];
    }
    return '';
  }

  function guard(modal) {
    var url = productUrl(modal);
    if (!/\/products\/[^/]*personalized/.test(url)) return;
    var forms = modal.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;
    Array.prototype.forEach.call(forms, function (f) {
      if (f.hasAttribute('data-pp-guarded')) return;
      /* Only the buy form; the theme's installments form has no add button. */
      var add = f.querySelector('button[name="add"], button[type="submit"]');
      if (!add) return;
      f.setAttribute('data-pp-guarded', '');
      modal.classList.add('pp-qv-guarded');
      var link = document.createElement('a');
      link.href = url;
      link.className = (add && add.className) || 'btn btn--primary';
      link.classList.add('pp-qv-personalize');
      link.textContent = 'Personalize it';
      link.style.cssText = 'display:flex;align-items:center;justify-content:center;width:100%;text-decoration:none';
      Array.prototype.forEach.call(f.querySelectorAll('button[name="add"], button[type="submit"], .shopify-payment-button'), function (b) {
        b.style.display = 'none';
      });
      var spot = (add && add.parentNode) || f;
      spot.insertBefore(link, spot.firstChild);
    });
  }

  /* Belt and braces: a personalized product's drawer can never submit to the cart. */
  document.addEventListener('submit', function (e) {
    var modal = e.target.closest && e.target.closest('quick-view-modal');
    if (!modal) return;
    var url = productUrl(modal);
    if (/\/products\/[^/]*personalized/.test(url)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = url;
    }
  }, true);

  /* Phones: the drawer drops the Shop Pay installments line and folds the description into a
     closed "Details" dropdown, and shows the photo a little smaller, so the buy (or Personalize it)
     button shows without scrolling. */
  var style = document.createElement('style');
  style.textContent =
    '@media (max-width:749px){' +
    'quick-view-modal form.installment{display:none!important}' +
    'quick-view-modal .product__media-item-container{width:56%;margin:0 auto}' +
    'quick-view-modal .product__media-list{height:auto!important;align-items:flex-start}' +
    '.pp-qv-guarded quantity-input{display:none!important}' +
    '.pp-qv-details{border-top:1px solid rgba(109,88,75,.2);border-bottom:1px solid rgba(109,88,75,.2)}' +
    '.pp-qv-details>summary{display:flex;align-items:center;justify-content:space-between;padding:12px 0;cursor:pointer;list-style:none;font-family:var(--font-body-family);font-size:13px;font-weight:500;letter-spacing:.12em;text-transform:uppercase}' +
    '.pp-qv-details>summary::-webkit-details-marker{display:none}' +
    '.pp-qv-details>summary::after{content:"+";font-size:18px;font-weight:400;letter-spacing:0}' +
    '.pp-qv-details[open]>summary::after{content:"\\2212"}' +
    '.pp-qv-details>.product__block--description{padding-bottom:12px}' +
    '}';
  document.head.appendChild(style);
  var phone = window.matchMedia('(max-width: 749px)');

  function foldDetails(modal) {
    if (!phone.matches) return;
    modal.querySelectorAll('.product__block--description').forEach(function (desc) {
      if (desc.closest('.pp-qv-details')) return;
      var box = document.createElement('details');
      box.className = 'pp-qv-details';
      var sum = document.createElement('summary');
      sum.textContent = 'Details';
      box.appendChild(sum);
      desc.parentNode.insertBefore(box, desc);
      box.appendChild(desc);
    });
  }

  function watch(modal) {
    if (modal.hasAttribute('data-pp-watch')) return;
    modal.setAttribute('data-pp-watch', '');
    guard(modal);
    foldDetails(modal);
    new MutationObserver(function () { guard(modal); foldDetails(modal); }).observe(modal, { childList: true, subtree: true });
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('quick-view-modal'), watch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  /* Drawers can arrive later (sections that load on scroll); check at most once a frame. */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
